// extracted by mini-css-extract-plugin
export default {"products":"order_products__kx17r","title":"order_title__cRCuz","productList":"order_productList__1GoHS","header":"order_header__8hxww","product":"order_product__n8cIk"};